import { render, staticRenderFns } from "./BaseItemList.vue?vue&type=template&id=01480af3&scoped=true&lang=pug&"
import script from "./BaseItemList.vue?vue&type=script&lang=js&"
export * from "./BaseItemList.vue?vue&type=script&lang=js&"
import style0 from "./BaseItemList.vue?vue&type=style&index=0&id=01480af3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01480af3",
  null
  
)

export default component.exports